import { useEffect, useState } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { toastr } from '../../services/toast-service';
import SlidingPanel from 'react-sliding-side-panel';
import { t } from 'i18next';
import { useAtomValue } from 'jotai';
import { Box } from '@mui/material';

import LineAwesome from '../LineAwesome/LineAwesome';
import { regionStore } from '../../store/jotai/store';
import { basketService } from '../../services/basket-service';
import { useWindowSize } from '../../utils/hooks/useWindowSize';
import { authAtom } from '../../store/jotai/atoms/auth.atom';
import BasketItems from './BasketItems';
import './BasketDropdown.scss';

interface BasketDropdownProps extends RouteComponentProps {
  openCard: boolean;
  toggleCart: () => void;
}

const BasketDropdown = ({ openCard, toggleCart }: BasketDropdownProps) => {
  const [width] = useWindowSize();
  const [windowWidth, setWindowWidth] = useState(50);
  const isAuthenticated = useAtomValue(authAtom, { store: regionStore }) === 'authenticated';

  useEffect(() => {
    if (openCard && isAuthenticated) {
      basketService.getBasket().catch(() => {
        toastr.error(
          t('basket.errorLoadingBasket', 'Fehler beim Laden des Warenkorbs.'),
          t('errors.generalError')
        );
      });
    }
  }, [openCard]);

  useEffect(() => {
    let newWidth = 50;
    if (width > 1399) {
      newWidth = 30;
    }
    if (width > 991 && width < 1399) {
      newWidth = 40;
    }
    if (width < 769) {
      newWidth = 100;
    }
    if (windowWidth !== newWidth) {
      setWindowWidth(newWidth);
    }
  }, [width]);

  return (
    <SlidingPanel type='right' isOpen={openCard} size={windowWidth} backdropClicked={toggleCart}>
      <Box className='card-overlay'>
        <Box className='close-card'>
          <LineAwesome icon='times-circle' onClick={toggleCart} />
        </Box>
        <BasketItems toggleCart={toggleCart} />
      </Box>
    </SlidingPanel>
  );
};

export default withRouter(BasketDropdown);
